<template>
  <div class="ba-w-100">
    <div class="container-box" v-if="pages.length > 0">
      <site-card-restore-page
        @restored="redirect"
        v-for="(page, index) in pages"
        :key="`page-${index}`"
        :page="page"
        :website="website"
      ></site-card-restore-page>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SiteCardRestorePage from "../layout/site/SiteCardRestorePage";
import { getDeletedPages } from "../../../js/services/editor/page";

export default {
  components: { SiteCardRestorePage },
  data() {
    return {
      pages: [],
    };
  },
  methods: {
    get() {
      this.pages = [];
      getDeletedPages(this.$route.params.id).then((response) => {
        this.pages = response.data.data;
      });
    },
    redirect() {
      this.$store.commit('website', false);
      this.$router.push({
        name: 'SitePages',
        params: {id: this.$route.params.id}
      });
    },
  },
  mounted() {
    this.get();
  },
  computed: {
    ...mapGetters({ website: "website" }),
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media (min-width: 1200px) {
    max-width: 1160px;
  }
}
.container-box {
  width: 100%;

  display: grid;

  grid-template-columns: 1fr;
  row-gap: 15px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    row-gap: 25px;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 25px;
    row-gap: 30px;
  }

  .box {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/WebsiteRestorePages.vue